/* La línea de tiempo de vencimientos de una unidad — SÓLO cálculo, sin React.
 *
 * Entra una lista de vencimientos `{ clave, label, dias }` (días hasta el
 * vencimiento: negativo = ya venció, 0 = hoy, positivo = falta) y sale todo lo
 * que la pantalla necesita para dibujarlos sobre un eje fijo. Puro para poder
 * probarlo en una tabla, igual que `shared/rto.js`.
 *
 * ── EL EJE ES FIJO Y ASIMÉTRICO ─────────────────────────────────────────────
 *
 * De 60 días atrás a 180 adelante. Atrás alcanza con poco: un vencimiento que
 * pasó hace tres meses ya no es la tarea de esta semana (es la misma idea que
 * `DIAS_VIEJO` del RTO). Adelante conviene ver medio año, que es lo que permite
 * sacar el turno antes de que apure. Lo que cae afuera del eje se clava en la
 * punta y se marca `fueraDeRango`, para no mentir que está donde no está.
 *
 * ── LOS CORTES SON LOS DEL RESTO DEL HUB ────────────────────────────────────
 *
 * `vencida` (<0), `por_vencer` (≤30, el `DIAS_AVISO` de portería y seguros) y
 * `al_dia`. Sin número es `sin_dato`: no se pone en el eje —no se inventa una
 * posición— y se lista aparte. «No sé cuándo vence» no es «está al día».
 */

export const DIAS_ATRAS = 60;
export const DIAS_ADELANTE = 180;
export const DIAS_AVISO = 30;

export function estadoDeDias(dias) {
  if (dias === null || dias === undefined) return "sin_dato";
  if (dias < 0) return "vencida";
  if (dias <= DIAS_AVISO) return "por_vencer";
  return "al_dia";
}

export function textoDeDias(dias) {
  if (dias === null || dias === undefined) return "sin dato";
  if (dias === 0) return "hoy";
  if (dias < 0) return `hace ${Math.abs(dias)} d`;
  return `en ${dias} d`;
}

/* La posición en el eje, en porcentaje (0 = punta izquierda, 100 = derecha),
 * clavada en los bordes para lo que se sale del rango. */
function posicion(dias, atras, adelante) {
  const x = ((dias + atras) / (atras + adelante)) * 100;
  return Math.max(0, Math.min(100, Math.round(x * 100) / 100));
}

export function linea(
  items,
  { atras = DIAS_ATRAS, adelante = DIAS_ADELANTE } = {},
) {
  const hitos = [];
  const sinDato = [];
  for (const it of items || []) {
    if (!it || !it.clave) continue;
    const dias = it.dias;
    if (dias === null || dias === undefined) {
      sinDato.push({ clave: it.clave, label: it.label });
      continue;
    }
    hitos.push({
      clave: it.clave,
      label: it.label,
      dias,
      estado: estadoDeDias(dias),
      texto: textoDeDias(dias),
      pct: posicion(dias, atras, adelante),
      fueraDeRango: dias < -atras || dias > adelante,
    });
  }
  // Ordenados por fecha: el más vencido primero, para que la lectura de
  // izquierda a derecha coincida con el eje.
  hitos.sort((a, b) => a.dias - b.dias);
  return {
    hitos,
    sinDato,
    hoyPct: posicion(0, atras, adelante),
    atras,
    adelante,
  };
}
